import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../utils/firebase';
import {
  ARCH_ENGINEER_WORK_QUEUE_DOC_ID,
  parseQueuesByUserIdFromFirestore,
} from '../utils/archEngineerWorkQueue';

/** Live `queuesByUserId` from `settings/arch_engineer_work_queue`. */
export function useArchEngineerWorkQueues(): Record<string, string[]> {
  const [queuesByUserId, setQueuesByUserId] = useState<Record<string, string[]>>({});

  useEffect(() => {
    const ref = doc(db, 'settings', ARCH_ENGINEER_WORK_QUEUE_DOC_ID);
    return onSnapshot(
      ref,
      (snap) => {
        setQueuesByUserId(parseQueuesByUserIdFromFirestore(snap.data()));
      },
      (err) => {
        console.error('arch_engineer_work_queue snapshot:', err);
        setQueuesByUserId({});
      },
    );
  }, []);

  return queuesByUserId;
}
